import {Button, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import type {ReactElement} from 'react'

import {FloatingBox, StickyTo} from '../../components/FloatingBox'
import {renderWidget} from '..'
import type {ActionButtonWidgetProps as Props} from '../types'
import * as classes from './ActionButton.classes'
import {useActionButtonProps} from './hooks'

export function ActionButtonWidget(props: Props): ReactElement {
  const {style, size, handlePress, actionElement} = useActionButtonProps(props)

  return (
    <FloatingBox className={classes.floatingWrapper} height={spacing(9)} stickyTo={StickyTo.BLOCK_END}>
      <Paper className={classes.actionButtonWrapper} padding="S" radius="L">
        <Button
          disabled={!style.enabled}
          flexDirection="column"
          justifyContent={style.slot.align}
          onPress={handlePress}
          size={size}
          variant="action"
          fullWidth
        >
          {style.slot.title.items.map(renderWidget)}
          {style.slot.subtitle && style.slot.subtitle.items.map(renderWidget)}
          {actionElement}
        </Button>
      </Paper>
    </FloatingBox>
  )
}
